// 协议制度页面 接口集合
import request from '../request.js'

// 协议制度-分页查询规章制度 --- 李开明
export const getRules = function (data) {
    return request({
        url: 'operatesysrule/selectRulePage',
        method: 'post',
        data
    })
}


// 用户协议-查询协议详情 --- 赵建强
export const getDealDetail = function (data) {
    return request({
        url: 'public/getDealDetail',
        method: 'post',
        data
    })
}

// 协议制度-设置协议状态 --- 李开明
export const setFlag = function (data) {
    return request({
        url: 'operatesysrule/setAgreementStatus',
        method: 'post',
        data
    })
}

// 协议制度-新增或修改规章制度 --- 李开明
export const saveRules = function (data) {
    return request({
        url: 'operatesysrule/insertOrUpdateRule',
        method: 'post',
        data
    })
}

// 协议制度-删除规章制度 --- 李开明
export const deleteRule = function (data) {
    return request({
        url: 'operatesysrule/deleteRule',
        method: 'post',
        data
    })
}

// 协议制度-查询应用范围的树结构 --- 李开明
export const getRange = function (data) {
    return request({
        url: 'operatesysrule/selectAppliedRange',
        method: 'post',
        data
    })
}

// 平台制度-分页查询平台制度 --- 李开明
export const insertOrUpdateRegime = function (data) {
    return request({
        url: 'operateSysRegime/insertOrUpdateRegime',
        method: 'post',
        data
    })
}

// 平台制度-分页查询平台制度 --- 李开明
export const selectRegimePage = function (data) {
    return request({
        url: 'operateSysRegime/selectRegimePage',
        method: 'post',
        data
    })
}

// 平台制度-删除平台制度 --- 李开明
export const deleteRegime = function (data) {
    return request({
        url: 'operateSysRegime/deleteRegime',
        method: 'post',
        data
    })
}

// 设置平台制度状态 --- 李开明
export const setAgreementStatusPt = function (data) {
    return request({
        url: 'operateSysRegime/setAgreementStatus',
        method: 'post',
        data
    })
}

// 帮助文档目录结构新增/修改 --- 俞祥东
export const saveOrEditHelpCatalog = function (data) {
    return request({
        url: 'helpCatalog/saveOrEditHelpCatalog',
        method: 'post',
        data
    })
}

// 帮助文档目录结构删除 --- 俞祥东
export const delHelpCatalog = function (data) {
    return request({
        url: 'helpCatalog/delHelpCatalog',
        method: 'post',
        data
    })
}

// 帮助文档目录结构查询回显 --- 李开明
export const selHelpCatalog = function (data) {
    return request({
        url: 'helpCatalog/selHelpCatalogs',
        method: 'post',
        data
    })
}

// 帮助中心内容新增、修改 --- 李开明
export const saveOrEditHelpDetail = function (data) {
    return request({
        url: 'helpDetail/saveOrEditHelpDetail',
        method: 'post',
        data
    })
}

// 帮助中心内容删除 --- 李开明
export const delHelpDetail = function (data) {
    return request({
        url: 'helpDetail/delHelpDetail',
        method: 'post',
        data
    })
}

// 帮助中心内容查询列表 --- 李开明
export const selHelpDetailList = function (data) {
    return request({
        url: 'helpDetail/selHelpDetailPageList',
        method: 'post',
        data
    })
}
// 帮助中心内容查询详情 --- 朱新宇
export const getHelpDetail = function (data) {
    return request({
        url: '/helpDetail/getHelpDetail',
        method: 'post',
        data
    })
}

// 用户协议-新增或修改用户协议 --- 赵建强
export const saveDeal = function (data) {
    return request({
        url: '/userDeal/saveDeal',
        method: 'post',
        data
    })
}

// 用户协议-列表查询 --- 赵建强
export const getDealList = function (data) {
    return request({
        url: '/userDeal/getDealList',
        method: 'post',
        data
    })
}
// 用户协议-删除协议 --- 赵建强
export const delDeal = function (data) {
    return request({
        url: '/userDeal/delDeal',
        method: 'post',
        data
    })
}
// 协议版本-分页列表查询 --- 赵建强
export const getVersionPageList = function (data) {
    return request({
        url: '/dealVersion/getVersionPageList',
        method: 'post',
        data
    })
}
// 协议版本-新增修改 --- 赵建强
export const saveVersion = function (data) {
    return request({
        url: '/dealVersion/saveVersion',
        method: 'post',
        data
    })
}
// 协议版本-删除 --- 赵建强
export const delVersion = function (data) {
    return request({
        url: '/dealVersion/delVersion',
        method: 'post',
        data
    })
}
// 协议版本-明细查询 --- 赵建强
export const getVersion = function (data) {
    return request({
        url: '/dealVersion/getVersion',
        method: 'post',
        data
    })
}

// 协议配置-分页列表查询 --- 赵建强
export const getConfigPageList = function (data) {
    return request({
        url: '/dealConfig/getConfigPageList',
        method: 'post',
        data
    })
}

// 协议配置-明细查询 --- 赵建强
export const getConfig = function (data) {
    return request({
        url: '/dealConfig/getConfig',
        method: 'post',
        data
    })
}

// 协议配置-查询协议分页列表 --- 赵建强
export const getDealPageList = function (data) {
    return request({
        url: '/dealConfig/getDealPageList',
        method: 'post',
        data
    })
}

// 协议配置-新增修改 --- 赵建强
export const saveConfig = function (data) {
    return request({
        url: '/dealConfig/saveConfig',
        method: 'post',
        data
    })
}
// 协议配置-变更状态 --- 赵建强
export const changeStatus = function (data) {
    return request({
        url: '/dealConfig/changeStatus',
        method: 'post',
        data
    })
}

// 协议配置-删除 --- 赵建强
export const delConfig = function (data) {
    return request({
        url: '/dealConfig/delConfig',
        method: 'post',
        data
    })
}

//资讯公告文档目录结构节点查询回显(查询至第二级节点)------高进
export const selInformation = function (data) {
    return request({
        url: '/infocatalog/selHelpCatalogs',
        method: 'post',
        data
    })
}

//资讯公告文档目录结构节点删除------高进
export const delInformation = function (data) {
    return request({
        url: '/infocatalog/delHelpCatalog',
        method: 'post',
        data
    })
}

//资讯公告文档目录结构节点新增/修改------高进
export const saveOrEditInformation = function (data) {
    return request({
        url: '/infocatalog/saveOrEditBaseInfoCatalog',
        method: 'post',
        data
    })
}

//资讯公告中心内容查询------高进
export const selInformationDetailList = function (data) {
    return request({
        url: '/infoDetail/selHelpDetailPageList ',
        method: 'post',
        data
    })
}

//资讯公告中心内容查询详情 ------ 朱新宇
export const getInfoDetail = function (data) {
    return request({
        url: '/infoDetail/getHelpDetail ',
        method: 'post',
        data
    })
}

//资讯公告中心内容新增/修改------高进
export const saveOrEditImformationDetail = function (data) {
    return request({
        url: '/infoDetail/saveOrEditHelpDetail',
        method: 'post',
        data
    })
}

//资讯公告中心内容删除------高进
export const delInformationDetail = function (data) {
    return request({
        url: '/infoDetail/delHelpDetail',
        method: 'post',
        data
    })
}
// 资讯公告置顶------李同雷
export const editInfoDetailTop = function (data) {
    return request({
        url: '/infoDetail/editInfoDetailTop',
        method: 'post',
        data
    })
}
